import { apiV2, errorHandler } from './index';
import {
  API_ERROR,
  FETCH_ALL_PROMO_BANNERS,
} from '../constants/ActionTypes';
import Swal from 'sweetalert2';

export function fetchAllPromoBanners() {
  return function (dispatch) {
    apiV2.get(`/promo-banners`)
      .then(response => {
        dispatch({
          type: FETCH_ALL_PROMO_BANNERS,
          payload: response.data.objects
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function fetchOnePromoBanner(promoBannerId) {
  return function (dispatch) {
    return apiV2.get(`/promo-banners/${promoBannerId}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function updatePromoBannerOrder(promo_banner_ids) {
  return function (dispatch) {
    const data = typeof promo_banner_ids === 'string' ? JSON.parse(promo_banner_ids) : promo_banner_ids;
    apiV2.put('/promo-banners/update-order', { data })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function addEditPromoBanner(promo_banner_json, onSuccess) {
  return function (dispatch) {
    const data = typeof promo_banner_json === 'string' ? JSON.parse(promo_banner_json) : promo_banner_json;
    const request = data.promo_banner_id
      ? apiV2.put(`/promo-banners/${data.promo_banner_id}`, data)
      : apiV2.post('/promo-banners', data);

    request
      .then(response => {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          timer: 1000
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function deletePromoBanner(promo_banner_id, onSuccess) {
  return function (dispatch) {
    apiV2.delete(`/promo-banners/${promo_banner_id}`)
      .then(response => {
        Swal.fire({
          icon: "success",
          title: "Promo Banner Deleted!",
          timer: 1000
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}
